import { reviewBuilder, reviewPaginationBuilder } from 'src/builders/review';
import { ProductReviewsAPIResponse } from 'src/redux/reviews/thunks';

export const productReviewsAPIResponseBuilder = (
  response?: Partial<ProductReviewsAPIResponse>,
): ProductReviewsAPIResponse => ({
  reviews: [reviewBuilder(), reviewBuilder({ id: 2 }), reviewBuilder({ id: 4 })],
  pagination: reviewPaginationBuilder({ totalEntries: 3 }),
  ...response,
});
